module.exports = __webpack_public_path__ + "img/lindahlstudios-final-bigger-subtitle.d0c9389b.png";